import { render } from "./SelectPickupAddress.vue?vue&type=template&id=6f9cb9a5&scoped=true"
import script from "./SelectPickupAddress.vue?vue&type=script&lang=js"
export * from "./SelectPickupAddress.vue?vue&type=script&lang=js"

import "./SelectPickupAddress.vue?vue&type=style&index=0&id=6f9cb9a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9cb9a5"]])

export default __exports__